import { render } from "./singleProduct.vue?vue&type=template&id=35f36030&scoped=true"
import script from "./singleProduct.vue?vue&type=script&lang=js"
export * from "./singleProduct.vue?vue&type=script&lang=js"

import "./singleProduct.vue?vue&type=style&index=0&id=35f36030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f36030"]])

export default __exports__